<app-loader></app-loader>

<app-header *ngIf="!hideLayout" [title]="pageTitle" [showBack]="showBack"></app-header>

<main class="container flex-fill">
  <router-outlet></router-outlet>
</main>

<app-footer *ngIf="!hideLayout"></app-footer>